/* ============================================================
   DV Fiyat Alarmı — "Fiyat düşünce haber ver" formu (FAZ 3-A)
   ------------------------------------------------------------
   Kendi kendine yeten asset. Tema tarafındaki tek iz:
   layout/theme.liquid içinde bir <script defer src> satırı.

   - Yalnızca /products/ sayfalarında çalışır.
   - Özel ölçü sayfalarında BİLEREK çıkmaz (dalga özel ölçü fiyatına
     yansımıyor; tutamayacağımız söz verilmez).
   - Ürün verisi window.ShopifyAnalytics.meta'dan okunur (canlıda
     doğrulandı: product.id, product.handle, variants[].price kuruş,
     selectedVariantId).
   - Kayıt ucu: POST /api/tracking/public/alarm — açık rıza kutusu
     işaretli değilse gönderim yapılmaz.
   ============================================================ */
(function () {
  'use strict';
  if (window.__DV_FIYAT_ALARM__) return;
  window.__DV_FIYAT_ALARM__ = true;

  if (location.pathname.indexOf('/products/') === -1) return;

  var UC = 'https://dolcevita-massimo.ngrok.io/api/tracking/public/alarm';

  function urun() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (!m || !m.product || !m.product.id) return null;
      return m;
    } catch (e) { return null; }
  }

  function seciliFiyat(m) {
    try {
      var vs = m.product.variants || [];
      var vid = m.selectedVariantId ? String(m.selectedVariantId) : null;
      var v = null;
      for (var i = 0; i < vs.length; i++) {
        if (vid && String(vs[i].id) === vid) { v = vs[i]; break; }
      }
      if (!v && vs.length) v = vs[0];
      if (!v || !(v.price > 0)) return { vid: vid, fiyat: null };
      return { vid: String(v.id), fiyat: v.price / 100 };
    } catch (e) { return { vid: null, fiyat: null }; }
  }

  function handleCoz(m) {
    if (m && m.product && m.product.handle) return String(m.product.handle);
    var t = /\/products\/([^/?#]+)/.exec(location.pathname);
    if (!t) return '';
    try { return decodeURIComponent(t[1]); } catch (e) { return t[1]; }
  }

  function kur() {
    // Özel ölçü sayfası mı? — çıkma.
    if (document.querySelector('[data-dv-order-flow]')) return;

    var m = urun();
    if (!m) return;

    var form = document.querySelector('form.hdt-main-product-form') ||
               document.querySelector('form[action^="/cart/add"]');
    if (!form || !form.parentNode) return;
    if (document.getElementById('dv-fiyat-alarm')) return;

    var kutu = document.createElement('div');
    kutu.id = 'dv-fiyat-alarm';
    kutu.style.cssText = 'margin:14px 0 6px;padding:12px 14px;border:1px solid #e3e3e3;border-radius:10px;background:#fafafa;font-size:13px;line-height:1.5;';
    kutu.innerHTML =
      '<button type="button" id="dv-fa-ac" style="all:unset;cursor:pointer;font-weight:600;font-size:13.5px;display:flex;align-items:center;gap:7px;color:#222;">' +
        '<span aria-hidden="true">&#128276;</span><span>Fiyat d&uuml;&#351;&uuml;nce haber ver</span>' +
      '</button>' +
      '<div id="dv-fa-panel" style="display:none;margin-top:10px;">' +
        '<div style="display:flex;gap:8px;flex-wrap:wrap;">' +
          '<input type="email" id="dv-fa-eposta" placeholder="E-posta adresiniz" autocomplete="email" ' +
            'style="flex:1;min-width:180px;padding:9px 12px;border:1px solid #ccc;border-radius:8px;font-size:13px;">' +
          '<button type="button" id="dv-fa-gonder" disabled ' +
            'style="padding:9px 18px;border:none;border-radius:8px;background:#bbb;color:#fff;font-weight:600;font-size:13px;cursor:not-allowed;">Kaydet</button>' +
        '</div>' +
        '<label style="display:flex;gap:7px;align-items:flex-start;margin-top:9px;cursor:pointer;color:#444;font-size:12px;">' +
          '<input type="checkbox" id="dv-fa-onay" style="margin-top:2px;">' +
          '<span>Bu &uuml;r&uuml;n&uuml;n fiyat&#305; d&uuml;&#351;t&uuml;&#287;&uuml;nde e-posta ile bilgilendirilmeyi ve bu ama&ccedil;la ' +
          'e-posta adresimin saklanmas&#305;n&#305; kabul ediyorum.</span>' +
        '</label>' +
        '<div id="dv-fa-durum" style="margin-top:7px;font-size:12px;min-height:16px;"></div>' +
      '</div>';

    form.parentNode.insertBefore(kutu, form.nextSibling);

    var ac = document.getElementById('dv-fa-ac');
    var panel = document.getElementById('dv-fa-panel');
    var eposta = document.getElementById('dv-fa-eposta');
    var onay = document.getElementById('dv-fa-onay');
    var gonder = document.getElementById('dv-fa-gonder');
    var durum = document.getElementById('dv-fa-durum');

    ac.addEventListener('click', function () {
      panel.style.display = (panel.style.display === 'none') ? 'block' : 'none';
    });

    function tazele() {
      var hazir = onay.checked && eposta.value.indexOf('@') > 0;
      gonder.disabled = !hazir;
      gonder.style.background = hazir ? '#1a7f37' : '#bbb';
      gonder.style.cursor = hazir ? 'pointer' : 'not-allowed';
    }
    onay.addEventListener('change', tazele);
    eposta.addEventListener('input', tazele);

    gonder.addEventListener('click', function () {
      if (gonder.disabled) return;
      var f = seciliFiyat(urun() || m);
      if (!(f.fiyat > 0)) {
        durum.textContent = 'Fiyat okunamadı, lütfen sayfayı yenileyin.';
        durum.style.color = '#b3261e';
        return;
      }
      gonder.disabled = true;
      gonder.textContent = '...';
      var govde = {
        eposta: eposta.value.trim(),
        pid: String(m.product.id),
        vid: f.vid,
        h: handleCoz(m),
        p: f.fiyat,
        c: onay.checked ? '1' : '0'
      };
      fetch(UC, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(govde),
        mode: 'cors',
        credentials: 'omit'
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (y) {
          if (y && y.ok) {
            panel.innerHTML = '<div style="color:#1a7f37;font-weight:600;font-size:13px;">' +
              '&#10003; Kaydedildi. Fiyat d&uuml;&#351;erse size e-posta g&ouml;nderece&#287;iz.</div>';
          } else {
            var h2 = (y && y.hata) || '';
            durum.textContent = h2 === 'gecersiz_eposta' ? 'Lütfen geçerli bir e-posta girin.'
              : h2 === 'cok_fazla_istek' ? 'Lütfen biraz sonra tekrar deneyin.'
              : 'Kaydedilemedi, lütfen tekrar deneyin.';
            durum.style.color = '#b3261e';
            gonder.textContent = 'Kaydet';
            tazele();
          }
        })
        .catch(function () {
          durum.textContent = 'Bağlantı hatası, lütfen tekrar deneyin.';
          durum.style.color = '#b3261e';
          gonder.textContent = 'Kaydet';
          tazele();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
})();
